
import { Injectable } from "@angular/core";
import { constantvalues } from '../../const';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { DtoUser, RegisterUser } from "../../models/user-center.model";
import { environment } from '../environments/environment.development'
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class LoginService {
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl; 
    }
    
    validateUser(userDetails: RegisterUser){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.AUTHENTICATE_USER}`, userDetails, 
        {
            headers: new HttpHeaders({
                skip: "true"  // Use HttpHeaders to set the 'skip' header
            })
        })
    }

    getUserDetails(userId: string): Observable<DtoUser>
    {
        return this.httpClient.get<DtoUser>(`${this.baseURL}${constantvalues.API_URL.USER_DETAILS}/${userId}`);
    }

    getDocumentApi(url: string): Observable<Blob>{
        return this.httpClient.get(
            `${this.baseURL}${url}`, 
            {
            responseType:'blob'
        });
    }
}